import { useTranslation } from 'react-i18next';

import { MailIcon } from 'assets';
import StyledButton from 'components/shared/StyledButton/StyledButton';
import { Banner } from 'storybook';

import styles from './SentPasswordResetNotification.module.css';

type SentPasswordResetNotificationProps = {
   onGoToLoginPage: () => void;
   email: string;
};

const SentPasswordResetNotification = ({
   onGoToLoginPage,
   email,
}: SentPasswordResetNotificationProps) => {
   const { t } = useTranslation();

   return (
      <div className={styles.mainContainer}>
         <span className={styles.iconContainer}>
            <MailIcon className={styles.icon} />
         </span>
         <h1>{t('sent_password_reset.title')}</h1>
         <Banner
            style={{ alignItems: 'baseline' }}
            children={t('sent_password_reset.description', { email })}
            variant="success"
            className={styles.banner}
         />
         <p className={styles.boldText}>{t('sent_password_reset.no_email_title')}</p>
         <ol>
            <li>{t('sent_password_reset.step_1')}</li>
            <li>{t('sent_password_reset.step_2')}</li>
            <li>{t('sent_password_reset.step_3')}</li>
         </ol>
         <p>{t('sent_password_reset.contact_help')}</p>
         <p>
            {t('sent_password_reset.phone')}:
            <span className={styles.boldText}> +48 71 383 06 13</span>
         </p>
         <p>
            {t('login.email')}:<span className={styles.boldText}> biuro@ndhp.pl</span>
         </p>
         <StyledButton
            text={t('forgot_password.back_to_login')}
            onClick={onGoToLoginPage}
            variant="filled-primary"
            className={styles.button}
         />
      </div>
   );
};

export default SentPasswordResetNotification;
